module.exports = __webpack_public_path__ + "img/tour-banner-catalogue.9feb7d61.svg";